import React from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { HotelDetailsCompleteResponse } from 'models/hotelDetailsComplete';

import {
  Container,
  BookingInfoHeader,
  BookingInfoDates,
  BookingInfoRooms,
  BookingInfoRoomsHeader,
  BookingInfoCheckin,
  BookingInfoCheckout,
  BookingInfoRoomsBody,
  BookingInfoTitle,
  EditIcon,
  EditContainer,
} from './styles';

export interface Props {
  details: HotelDetailsCompleteResponse;
}

const BookingInfo = ({ details }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  return (
    <Container>
      <BookingInfoHeader>
        <BookingInfoDates>
          <BookingInfoTitle>{t('hotelDetails.bookingInfoDates')}</BookingInfoTitle>
          <BookingInfoCheckin>{moment(details.checkinDate).utc().format('DD MMM')}</BookingInfoCheckin>
          <BookingInfoCheckout>{moment(details.checkoutDate).utc().format('DD MMM')}</BookingInfoCheckout>
        </BookingInfoDates>
        <BookingInfoRooms>
          <BookingInfoRoomsHeader>{t('hotelDetails.roomQuantity')}</BookingInfoRoomsHeader>
          <BookingInfoRoomsBody>{t('hotelDetails.guestQuantity')}</BookingInfoRoomsBody>
        </BookingInfoRooms>
      </BookingInfoHeader>
      <EditContainer>
        <EditIcon src="/corporate/images/edit-booking.svg" onClick={() => history.push('/corporate/booking/hotels')} />
      </EditContainer>
    </Container>
  );
};

export default BookingInfo;
